"use strict";
exports.__esModule = true;
exports.GdcMetadata = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/fp/isEmpty"));
var has_1 = tslib_1.__importDefault(require("lodash/has"));
/**
 * @public
 */
var GdcMetadata;
(function (GdcMetadata) {
    function isAttribute(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "attribute";
    }
    GdcMetadata.isAttribute = isAttribute;
    function isWrappedAttribute(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "attribute");
    }
    GdcMetadata.isWrappedAttribute = isWrappedAttribute;
    function isWrappedAttributeDisplayForm(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "attributeDisplayForm");
    }
    GdcMetadata.isWrappedAttributeDisplayForm = isWrappedAttributeDisplayForm;
    function isAttributeDisplayForm(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "attributeDisplayForm";
    }
    GdcMetadata.isAttributeDisplayForm = isAttributeDisplayForm;
    function isWrappedMetric(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "metric");
    }
    GdcMetadata.isWrappedMetric = isWrappedMetric;
    function isMetric(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "metric";
    }
    GdcMetadata.isMetric = isMetric;
    function isWrappedFact(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "fact");
    }
    GdcMetadata.isWrappedFact = isWrappedFact;
    function isFact(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "fact";
    }
    GdcMetadata.isFact = isFact;
    function isKpiAlert(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "kpiAlert";
    }
    GdcMetadata.isKpiAlert = isKpiAlert;
    function isWrappedKpiAlert(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "kpiAlert");
    }
    GdcMetadata.isWrappedKpiAlert = isWrappedKpiAlert;
    function isDataSet(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "dataSet";
    }
    GdcMetadata.isDataSet = isDataSet;
    function isWrappedDataSet(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "dataSet");
    }
    GdcMetadata.isWrappedDataSet = isWrappedDataSet;
    function isPrompt(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "prompt";
    }
    GdcMetadata.isPrompt = isPrompt;
    function isWrappedPrompt(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "prompt");
    }
    GdcMetadata.isWrappedPrompt = isWrappedPrompt;
    function isTheme(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "theme";
    }
    GdcMetadata.isTheme = isTheme;
    function isWrappedTheme(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "theme");
    }
    GdcMetadata.isWrappedTheme = isWrappedTheme;
})(GdcMetadata = exports.GdcMetadata || (exports.GdcMetadata = {}));
//# sourceMappingURL=GdcMetadata.js.map